import { ConfigType } from '../utils/requestAPI';

type CreateTechniciansJobDataType = {
  title: string;
  drafts: {
    url: string | undefined;
  }[];
  pricingPlan: string; //pricingPlanId
  shippingAddress: string;
  notes: string[];
};

type AcceptRejectDataType = {
  status: string;
};
const draftmanJobApi = {
  createDraftmanJob: (data: CreateTechniciansJobDataType): ConfigType => {
    return {
      url: '/drafts-job/',
      method: 'post',
      data: data,
    };
  },
  updateDraftmanJob: (
    jobId: string,
    data: CreateTechniciansJobDataType
  ): ConfigType => {
    return {
      url: `/drafts-job/${jobId}`,
      method: 'put',
      data: data,
    };
  },
  deleteDraftmanJob: (jobId: string): ConfigType => {
    return {
      url: `/drafts-job/${jobId}`,
      method: 'delete',
    };
  },
  getAllDraftmanJob: (): ConfigType => {
    return {
      url: `/drafts-job`,
      method: 'get',
      config: { store: { action: 'set', key: 'draftmanJobsData.data' } },
    };
  },
  getSingleJobOfDraftman: (jobId: string): ConfigType => {
    return {
      url: `/drafts-job/${jobId}`,
      method: 'get',
      config: { store: { action: 'set', key: 'singleDraftmanJobData' } },
    };
  },
  acceptRejectDraftJob: (
    id: string,
    data: AcceptRejectDataType
  ): ConfigType => {
    return {
      url: `/drafts-job/${id}`,
      method: 'patch',
      data,
    };
  },
};

export default draftmanJobApi;
